import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const icons = ['🧠', '⚡', '🔍', '📌', '💡', '🎯'];

export default function Insights({ userId }) {
  const [insights, setInsights] = useState('');
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const fetchInsights = async () => {
    setLoading(true);
    setInsights('');
    try {
      const res = await axios.post('https://recallcode-backend.onrender.com/insights', {
        user_id: userId,
      });
      setInsights(res.data.insights);
      setLoaded(true);
    } catch (e) {
      setInsights('Could not load insights. Is the backend running?');
    }
    setLoading(false);
  };

  const lines = insights
    .split('\n')
    .map(l => l.trim())
    .filter(l => l.length > 0);

  return (
    <div>
      <motion.div
        className="glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2>🧠 Your Learning Patterns</h2>
        <p style={{ marginBottom: 20 }}>
          RecallCode analyses everything you have ever submitted and reflects
          on your recurring mistakes — so you can finally break the cycle.
        </p>

        {!loaded && !loading && (
          <button className="btn-primary" onClick={fetchInsights}>
            🔍 Analyse My Patterns
          </button>
        )}

        {loading && (
          <div className="loading">
            Reflecting on your history...
          </div>
        )}

        {loaded && !loading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            {lines.length > 0 ? (
              lines.map((line, i) => (
                <motion.div
                  key={i}
                  className="insight-item"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.1 }}
                >
                  <span className="insight-icon">
                    {icons[i % icons.length]}
                  </span>
                  <p style={{ fontSize: 14, color: '#333', lineHeight: 1.6 }}>
                    {line}
                  </p>
                </motion.div>
              ))
            ) : (
              <p style={{ color: '#999', fontSize: 14 }}>
                Not enough data yet. Submit a few solutions first!
              </p>
            )}

            <button
              className="btn-primary"
              onClick={fetchInsights}
              style={{ marginTop: 20 }}
            >
              🔄 Refresh Insights
            </button>
          </motion.div>
        )}
      </motion.div>

      <motion.div
        className="glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2>📊 How RecallCode Remembers</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {[
            { icon: '💾', label: 'retain()', desc: 'Every solution you submit is stored in memory' },
            { icon: '🔎', label: 'recall()', desc: 'Your history is fetched before every AI response' },
            { icon: '🪞', label: 'reflect()', desc: 'Patterns are analysed across all your sessions' },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 + i * 0.1 }}
              style={{
                display: 'flex',
                gap: 14,
                alignItems: 'flex-start',
                padding: '12px 0',
                borderBottom: i < 2 ? '1px solid rgba(72,199,116,0.1)' : 'none'
              }}
            >
              <span style={{ fontSize: 22 }}>{item.icon}</span>
              <div>
                <p style={{
                  fontFamily: 'monospace',
                  color: '#2d9e5f',
                  fontWeight: 700,
                  fontSize: 14,
                  marginBottom: 4
                }}>
                  {item.label}
                </p>
                <p style={{ fontSize: 13, color: '#666' }}>{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}